import { api } from './networkService';

class BlockedNumberService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/blocked-number`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch blokced number error:', error);
            throw error;
        }
    }

    static async checkPhone(phone) {
        try {
            const response = await api.get(`api/user/blocked-number/check`, {
                params: { phone }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch blokced number error:', error);
            throw error;
        }
    }

    static async add(blockedNumber) {
        try {
            const cleanedBlockedNumber = Object.fromEntries(
                Object.entries(blockedNumber).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/blocked-number`, cleanedBlockedNumber);
            return response;
        } catch (error) {
            console.error('Add blokced number error:', error);
            throw error;
        }
    }

    static async update(blockedNumber) {
        try {
            const { id, ...info } = blockedNumber;
            const cleanedBlockedNumber = Object.fromEntries(
                Object.entries(info).filter(([_, value]) => value && value !== '')
            );
            const response = await api.put(`api/user/blocked-number/${id}`, cleanedBlockedNumber);
            return response;
        } catch (error) {
            console.error('Update blokced number error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/blocked-number/${id}`);
            return response;
        } catch (error) {
            console.error('Delete blokced number error:', error);
            throw error;
        }
    }
}

export default BlockedNumberService;
